import type { NodeProps } from '../types';

const MARGIN_CLASSES = {
  0: 'mb-0',
  1: 'mb-1',
  2: 'mb-2',
  3: 'mb-4',
  4: 'mb-7',
  5: 'mb-11',
  '3-half': undefined,
} as const;

export type SpacerProps = NodeProps<{
  spacing: keyof typeof MARGIN_CLASSES;
}> & { nested?: boolean };

export function Spacer({ props }: SpacerProps) {
  // Legacy passes this raw string to spacing(), yielding invalid NaNrem; it has no margin.
  return <div className={MARGIN_CLASSES[props.spacing]} />;
}
